<template>
    <div>
        <digital-server :image_url="image_url" :icon_url="icon_url" 
                        :small_title="{en: context['看板'].left_top, ch: context['看板'].left_bottom}" 
                        :big_title="{title: context['看板'].title, content: context['看板'].content}"
        ></digital-server>
        <div class="pain">
            <div class="pain_container">
                <Title :title="context['行业痛点'].title" :content="context['行业痛点'].content"></Title>
                <div class="pain_items">
                    <div v-for="(item, index) in context['行业痛点'].item" :key="index" :class="['item', index <= 2 ? 'down' : '',  index === 1 || index === 4  ? 'sides' : '']">
                        <img :src="item.img">
                        <p class="p1">{{ item.title }}</p>
                        <p class="p2">{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 解决方案 -->
        <div class="resolve">
            <div class="resolve_container">
                <Title :title="context['解决方法'].title" :content="context['解决方法'].content"></Title>
                <resolve-project :projects="context['解决方法'].item"></resolve-project>
            </div>
        </div>
        <div class="video">
            <div class="video_container">
                <Title :title="context['成功案例'].title" :content="context['成功案例'].content"></Title>
                <SuccessVideo :cover="cover" :url="video_url" :company="context['成功案例'].company" :company_content="context['成功案例'].company_content"></SuccessVideo>
            </div>
        </div>
    </div>
</template>

<script>
import { baseUrl } from "../../util/constant"
import { getText, getVideos } from "../../util"
import { fromDictToArray } from "../../util/tool"
import digitalServer from "../../components/digitalServer"
import Title from '../../components/title'
import resolveProject from "../../components/resolveProjects"
import DigitalBar from '../../components/digitalBar'
import DigitalResolve from '../../components/digitalResolve'
import allCollapse from '../../components/allCollapse'
import SuccessVideo from '../../components/successVideo'
import { titleEnergy,digitalEnergy, energyPainPoints,successfulProjects, digitalServerHeader, collapseArray } from '../../util/constant'
export default {
    data() {
        return {
            image_url: require('../../assets/image/7.1.png'),
            icon_url: require('../../assets/image/资源121.png'),
            video_url: '',
            titleEnergy,
            digitalServerHeader,
            digitalEnergy,
            energyPainPoints,
            collapseValue: 0,
            collapseArray,
            painItemArray:[
                {
                    title:'信息数据分散',
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                },
                {
                    title:'信息数据分散',
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                },
                {
                    title:'信息数据分散',
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                },
                {
                    title:'信息数据分散',
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                }
            ],
            context: {
                '看板':{},
                '行业痛点':{},
                '解决方法':{},
                '成功案例':{}
            },
            cover: ''
        }
    },
    methods: {
        handleMouseEnter(id) {
            this.collapseValue = id; // 设置当前移入项为展开状态
        },
        handleMouseClick(id){
            if(this.collapseValue !== id) this.collapseValue = id
        },
    },
    components: {
        digitalServer,
        Title,
        // DigitalResolve,
        SuccessVideo,
        allCollapse,
        resolveProject,
    },
    mounted() {
        let page = '数字孪生+能源'
        getText(page).then(res=>{
            if(res.code === 200) {
                this.context['看板'] = res.data[0]
                this.context['行业痛点'] = res.data[1]
                this.context['行业痛点'].item = fromDictToArray(res.data[1])
                this.context['行业痛点'].item.forEach((item, index) =>{
                    if(index === 0) item.img = require('../../assets/image/7.2-数据孤岛与信息共享不足.png')
                    if(index === 1) item.img = require('../../assets/image/7.2-运营效率底下.png')
                    if(index === 2) item.img = require('../../assets/image/7.2-设备维护成本高.png')
                    if(index === 3) item.img = require('../../assets/image/7.2-安全管理.png')
                    if(index === 4) item.img = require('../../assets/image/7.2-能源供需平衡问题.png')
                    if(index === 5) item.img = require('../../assets/image/7.2-环保-可持续性挑战.png')
                })
                this.context['解决方法'] = res.data[2]
                this.context['解决方法'].item = fromDictToArray(res.data[2])
                this.context['解决方法'].item.forEach((item, index) =>{
                    item.image = require(`../../assets/image/7.3-${index+1}.png`)  
                })
                this.context['成功案例'] = res.data[3]
            }   
        })
        let key = 'energy_video'
        getVideos(page).then(res=>{
            if(res.code === 200) {
                this.cover = res.data[key].thumbnail
                this.video_url = res.data[key].url
            }
        }).catch(err=>{
            this.$message.error(err.message)
        })
    }
}
</script>

<style scoped lang="less">
.pain{
    .pain_container{
        // height: 800px;
        width: 100%;
        // padding-bottom: 5rem;
        padding: 5rem 0;
        background-color: rgb(23, 23, 23);
        // .pain_item{
        //     width: 80%;
        //     height: 60%;
        //     margin: 0 auto;
        //     display: flex;
        //     justify-content: space-between;
        //     .item_container{
        //         width: 20%;
        //         height: 100%;
        //         border-radius: 0.5rem;
        //         display: flex;
        //         flex-direction: column;
        //         justify-content: center;
        //         align-items: center;
        //         background-color: #545454;
        //         .line{
        //             width: 20%;
        //             margin: 15%;
        //             border-bottom: 2px solid #54d1ef;
        //         }
        //     }
        // }
    }
    .pain_items{
        display: flex;
        justify-content: center;
        margin: 0 auto;
        width: 84rem;
        background-color: rgb(23, 23, 23);
        flex-wrap: wrap;
        .item{
            width: 33%;
            // background-color: coral;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items: center;
            padding: 2rem 6rem;
            .p1{
                color: #ffffff;
                margin: 1.5rem 0
            }
            .p2{
                color: #9b9b9b;
                font-size: 0.8rem;
                // 字间距
                letter-spacing: 1px;
                line-height: 1.8;
            }
            .p1, .p2{
                text-align: center;
            }
        }
        .sides{
            border-left: 2px solid #636363;
            border-right: 2px solid #636363;
        }
        .down{
            border-bottom: 2px solid #636363;
        }
    }
}
.resolve{
    .resolve_container{
        background-color: #000;
        padding: 5rem 0;
        .collapse_test{
            width: 60%;
            display: flex;
            margin: 0 auto;
            .collapse_left{
                width: 50%;
                .collapse_item{
                    display: flex;
                    .item_left{
                        height: auto;
                        // background-color: #ff0000;
                        width: 8%;
                        display: flex;
                        justify-content: center;
                        .dashed{
                            width: 2px;
                            height: 200px; /* 虚线的高度 */
                            border-left: 2px dashed ; /* 使用虚线样式，并设置为透明 */
                            background: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.5)); /* 设置背景渐变，从白色透明度百分之百到百分之50 */
                            // background-image: repeating-linear-gradient(to bottom, white, rgb(131, 131, 131) 5px, #000000 5px, #000000 10px); /* 间隔为5px */
                        }
                    }
                    .item_right{
                        height: auto;
                        padding: 5px 6px 1rem 36px;
                        line-height: 2;
                        letter-spacing: 1px;
                        .item_context{
                            padding: 1rem 6rem 1rem 0;
                            font-size: 12px;
                            color: #868686;
                            line-height: 2;
                            letter-spacing: 2px;
                        }
                    }
                }
            }
            .collapse_right{
                width: 50%;
            }
        }
    }
}
.video{
    .video_container{
        background-color: #1e1d1d;
        padding: 5rem 0;
    }
}
::v-deep .el-dialog{
    background-color: #defade;
    opacity: 0.9;
    display: flex;
    justify-content: center;
}
::v-deep .el-collapse{
    border: none;
}
::v-deep .el-collapse-item__content{
    padding: 0;
}
::v-deep .el-collapse-item__arrow{
    display: none;
}
::v-deep .el-collapse-item__header{
    background-color: #000;
    border: none;
}
::v-deep .el-collapse-item__wrap{
    background-color: #000;
    border: none;
}
</style>